import clsx from "clsx";
import React, { useState } from "react";
import { useBreakpoints, useTheme } from "../../hooks";
import { StatusDrawerThemeType } from "../../types";
import Collapse from "../collapse/Collapse";
import { Drawer } from "../drawer";
import StatusDrawerHeader from "./StatusDrawerHeader";
import { StatusDrawerBody, StatusDrawerContainer } from "./StatusDrawerStyles";

type StatusDrawerProps = {
  statusDrawerKey: string;
  header: React.ReactNode;
  left?: string;
  bottom?: string;
  width?: string;
  onClick?: (value: boolean) => void;
  onClose?: () => void;
  startOpen?: boolean;
  animation?: boolean;
  className?: string;
  styles?: StatusDrawerThemeType;
};

const StatusDrawer: React.FC<React.PropsWithChildren<StatusDrawerProps>> = ({
  statusDrawerKey,
  children,
  header,
  left = "auto",
  width = "300px",
  bottom = "0",
  onClick,
  onClose,
  startOpen = false,
  animation = true,
  className = "",
  styles = {},
}) => {
  const { Theme } = useTheme();
  const { isMobile } = useBreakpoints();
  const StylesOverride: StatusDrawerThemeType = { ...Theme.statusDrawer, ...styles };
  const [isOpen, setIsOpen] = useState(startOpen);

  const toggle = (open: boolean) => {
    setIsOpen(open);
    if (!!onClick) {
      onClick(open);
    }
  };

  const Header = (
    <StatusDrawerHeader isOpen={isOpen} onClick={onClick} onClose={onClose}>
      {header}
    </StatusDrawerHeader>
  );

  return (
    <StatusDrawerContainer
      width={width}
      bottom={bottom}
      left={left}
      styles={StylesOverride}
      className={clsx("best-status-drawer", className)}
    >
      {isMobile ? (
        <>
          <div
            onClick={() => {
              toggle(true);
            }}
          >
            {Header}
          </div>
          <Drawer
            isOpen={isOpen}
            onClose={() => {
              toggle(false);
            }}
          >
            {children}
          </Drawer>
        </>
      ) : (
        <Collapse singleOpen={false} animation={animation}>
          <Collapse.Item
            header={Header}
            onToggle={toggle}
            collapseKey={statusDrawerKey}
            startsOpen={startOpen}
            styles={{
              ...Theme.collapse,
              header: {
                ...Theme.collapse.header,
                color: StylesOverride.header.color,
                background: StylesOverride.header.background,
                borderRadius: StylesOverride.header.borderRadius,
              },
            }}
          >
            <StatusDrawerBody styles={StylesOverride}>{children}</StatusDrawerBody>
          </Collapse.Item>
        </Collapse>
      )}
    </StatusDrawerContainer>
  );
};

export default StatusDrawer;
